import React from 'react';
import ImageLoader from 'react-render-image';
import { Image } from './styled';
export var ImageIcon = function ImageIcon(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    src = _ref.src,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    title = _ref.title,
    defaultIcon = _ref.default;
  // TODO: do we need this?
  if (!src) {
    return defaultIcon || null;
  }
  var LoadedImageComponent = /*#__PURE__*/React.createElement(Image
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  , {
    className: "smart-link-icon",
    src: src,
    alt: alt,
    size: size,
    title: title
  });
  return /*#__PURE__*/React.createElement(ImageLoader, {
    src: src,
    loading: defaultIcon,
    loaded: LoadedImageComponent,
    errored: defaultIcon
  });
};